
  import ImageCropper from "~/components/id-validator/ImageCropper.vue"
  import AreYouSurePopup from "@/components/da-signer/AreYouSurePopup.vue"

  export default {
    name: "IDValidationStep",
    components: {
      ImageCropper,
      AreYouSurePopup
    },
    props: {
      withMrz: {
        type: Boolean,
        default: true
      },
      documentType: {
        type: String,
        required: true
      },
      document: {
        type: String
      },
      crop: {
        type: Object,
        default: null
      },
      parentPassed: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        loading: false,
        passed: false,
        showSkip: false,
        skippedValidation: false,
        showNotRecognizedHelp: false,
        hasAnimated: false,
        wrongDocumentType: false,
        timer: null,
        justMounted: true
      }
    },
    computed: {
      language() {
        return this.$i18n.locale
      }
    },
    mounted() {
      this.passed = this.parentPassed
      console.log("Parent passed:", this.parentPassed)
    },
    methods: {
      onImageChanged() {
        setTimeout(() => {
          this.justMounted = false
        }, 1000)

        if (this.justMounted && !this.withMrz) {
          return
        }
        if (this.passed || this.timer) {
          clearTimeout(this.timer)
        }
        if (!this.passed) {
          this.timer = setTimeout(() => {
            this.checkID()
          }, 1000)
        }
      },
      async checkID() {
        if (this.passed) {
          return
        }
        const cropperRef = this.$refs.cropper
        if (!cropperRef) {
          return
        }
        const croppedImage = cropperRef.cropImage()
        const fullImage = cropperRef.getFullImage()
        const cropperData = cropperRef.getCropperData()
        console.log(`Cropper Data:`, cropperData)

        if (!this.withMrz) {
          // Wait for 1 second to simulate processing
          this.loading = true
          await new Promise((resolve) => setTimeout(resolve, 1000))
          this.loading = false
          this.passed = true
          this.$emit("validation-complete", {
            fullImage,
            crop: cropperData,
            report: "",
            signature: ""
          })
          return
        }

        setTimeout(() => {
          this.showSkip = true
          this.$emit("allow-skip")
        }, 15 * 1000)

        try {
          this.loading = true
          this.passed = false

          const result = await this.$store.dispatch(`idValidator/checkDocument`, {
            image: croppedImage,
            documentType: this.documentType
          })

          this.passed = result.valid === true
          if (this.passed === false && result.code === `document_type_mismatch`) {
            this.wrongDocumentType = true
          }

          if (this.passed) {
            this.$emit("validation-complete", {
              fullImage,
              crop: cropperData,
              report: result.report || "",
              signature: result.signature || ""
            })
          }
        } catch (error) {
          console.error(`Error checking ID:`, error)
          this.$emit("validation-error", error)
        } finally {
          this.loading = false
        }
      },
      documentNotRecognizedPopUp() {
        this.showNotRecognizedHelp = true
      },
      skipValidation() {
        const cropperRef = this.$refs.cropper
        const fullImage = cropperRef.getFullImage()
        const croppedData = cropperRef.getCropperData()

        this.$emit("validation-complete", {
          fullImage,
          crop: croppedData,
          report: "",
          signature: ""
        })
      },
      onCropperCleared() {
        this.$emit("cleared")
      },
      getCroppedImage() {
        const cropperRef = this.$refs.cropper
        return cropperRef ? cropperRef.cropImage() : null
      },
      getFullImage() {
        const cropperRef = this.$refs.cropper
        return cropperRef ? cropperRef.getFullImage() : null
      },
      clear() {
        const cropperRef = this.$refs.cropper
        if (cropperRef) {
          cropperRef.clear()
        }
      }
    }
  }
